export default __webpack_public_path__ + "static/media/mobile-with-logo.be27f910.png";